(() => {
  const root = document.querySelector('[data-rh-air3-hero]');
  const productId = root?.dataset.productId;
  if (!root || !/^\d+$/.test(productId || '')) return;
  const selector = document.getElementById(`stick-variant-${productId}`);
  const sync = () => {
    const variantId = String(selector?.value || root.dataset.selectedVariantId || '');
    if (!/^\d+$/.test(variantId)) return;
    for (const id of [`product-form-${productId}`, `product-form-installment-${productId}`, `product-form-sticky-${productId}`]) {
      for (const container of document.querySelectorAll(`[id="${id}"]`)) {
        for (const input of container.querySelectorAll('input[name="id"]')) {
          if (input.value === variantId) continue;
          input.value = variantId;
        }
      }
    }
  };
  const scheduleSync = () => {
    sync();
    setTimeout(sync, 0);
    setTimeout(sync, 250);
  };
  root.dataset.rhStickySyncReady = 'true';
  scheduleSync();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleSync, {once: true});
  selector?.addEventListener('change', scheduleSync);
  document.addEventListener('submit', sync, true);
  document.addEventListener('click', (event) => {
    if (event.target?.closest?.('#product-add-to-cart, #product-sticky-add-to-cart')) sync();
  }, true);
})();
